import { ImageType } from '../../models/ImageType.enum';
import { IRasterImg } from '../../models/IRasterImg';

export class RasterImgWrapper {
    private base64Img: string;
    private _anchor: HTMLAnchorElement;
    private stageID: string;

    constructor(base64: string, type: ImageType, stageID?: string) {
        this.base64Img = base64;
        this._imgType = type;
        this.stageID = stageID;
    }

    private _imgType: ImageType;

    public get imgType(): ImageType {
        return this._imgType;
    }

    public getImg(): IRasterImg {
        return {
            type: this._imgType,
            stageID: this.stageID,
            base64: this.base64Img,
        };
    }

    public download(filename: string): void {
        this.createAnchor(filename);
        document.body.appendChild(this._anchor);
        this._anchor.click();
        this.removeAncor();
    }

    private createAnchor(filename: string): void {
        this._anchor = document.createElement('a');
        this._anchor.download = filename;
        this._anchor.href = this.base64Img;
        this._anchor.style.display = 'none';
    }

    private removeAncor(): void {
        this._anchor.remove();
    }
}
